import type { PublisherLevel } from '../types';

import { ETooltipContent } from './constants';

export function getTooltipContent(agentLevel: PublisherLevel): string {
  switch (agentLevel) {
    case 'verified':
      return ETooltipContent.Second;
    case 'experienced':
      return ETooltipContent.Third;
    case 'professional':
      return ETooltipContent.Fourth;
    default:
      return ETooltipContent.Nothing;
  }
}

export function getLevelName(agentLevel: PublisherLevel): string {
  switch (agentLevel) {
    case 'verified':
      return 'Проверенный';
    case 'experienced':
      return 'Опытный';
    case 'professional':
      return 'Профи';
    default:
      return '';
  }
}
